module.exports = __webpack_public_path__ + "static/media/bad-phone-number.9ad7a855.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/bad-phone-number.svg
// module id = 879
// module chunks = 0